import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { makeStyles } from '@material-ui/styles'
import Modal from 'core/elements/modal'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import { logoutUrl } from 'app/constants'
import Theme from 'core/themes/model'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  message: {
    marginBottom: theme.spacing(2),
  },
}))

const NoRegionsOverlay = () => {
  const classes = useStyles()

  const history = useHistory()

  const [countdown, setCountdown] = useState(5)

  const handleLogout = () => {
    history.push(logoutUrl)
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          handleLogout()
          return 0
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  return (
    <Modal
      open={true}
      panel="dialog"
      onClose={() => {}}
      onBackdropClick={() => {}}
      title="No Regions Available"
      data-testid="no-regions-modal"
    >
      <div className={classes.root}>
        <Text variant="body1" className={classes.message}>
          We couldn't find a valid region, so we're redirecting you to the login page ({countdown}
          sec).
        </Text>
      </div>
    </Modal>
  )
}

export default NoRegionsOverlay
